import type { DeploymentLineLegalNotice } from "le-coffre-resources/dist/deploymentLineLegalPublisher";

import { LegalNoticeLine, LegalNoticeMailLink, LegalNoticeSectionTitle } from "./LegalNoticePrimitives";

type LegalNoticeOwnerProps = {
	notice: DeploymentLineLegalNotice;
};

export function LegalNoticeOwner(props: LegalNoticeOwnerProps): React.JSX.Element {
	const { notice } = props;
	return (
		<>
			<LegalNoticeSectionTitle>01 Propriétaire du site</LegalNoticeSectionTitle>
			<LegalNoticeLine>{notice.ownerName}</LegalNoticeLine>
			<LegalNoticeLine>Siège social : {notice.ownerRegisteredOffice}</LegalNoticeLine>
			<LegalNoticeLine>SIRET : {notice.ownerSiret}</LegalNoticeLine>
			<LegalNoticeLine>TVA intracommunautaire : {notice.ownerVatIntra}</LegalNoticeLine>
			<LegalNoticeLine>RCS : {notice.ownerRcs}</LegalNoticeLine>
			<LegalNoticeLine>Directeur de la publication : {notice.publicationDirectorName}</LegalNoticeLine>
			<LegalNoticeLine>
				Contact : <LegalNoticeMailLink email={notice.ownerContactEmail} />
			</LegalNoticeLine>
		</>
	);
}
